import IcoIconContainer from "../../../Components/Icon/IcoIcon/IcoIconContainer";

const IcoIcon = () => {
  return <IcoIconContainer />;
};

export default IcoIcon;
